// ─── Helpers ─────────────────────────────────────────────────────────────────

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  // Sanitize filename — strip path separators and shell-special chars
  a.download = filename.replace(/[/\\:*?"<>|]/g, "_");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// ─── V-01: CSV Formula Injection prevention ───────────────────────────────────
// Fields starting with =, +, -, @, tab, CR are prefixed with ' to neutralize
// formula execution in Excel, LibreOffice, and Google Sheets.
// ALL fields are double-quoted regardless of content.
const FORMULA_TRIGGERS = /^[=+\-@\t\r]/;

function csvEscape(value) {
  const str = String(value ?? "");
  const safe = FORMULA_TRIGGERS.test(str) ? `'${str}` : str;
  return `"${safe.replace(/"/g, '""')}"`;
}

// ─── V-12: UTF-8 BOM for correct Excel rendering ─────────────────────────────
const UTF8_BOM = "\uFEFF";

const DISCLAIMER =
  "# LEGAL DISCLAIMER: This export is for educational/legal OSINT only. Do not use to gain unauthorized access.";

// ─── JSON Export ──────────────────────────────────────────────────────────────
export function exportJSON(dorks) {
  const data = {
    disclaimer: "For educational and legal OSINT use only.",
    generated_by: "ReconDork v2.0",
    timestamp: new Date().toISOString(),
    total: dorks.length,
    dorks,
  };
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json;charset=utf-8;",
  });
  downloadBlob(blob, `recondork-${Date.now()}.json`);
}

// ─── CSV Export ───────────────────────────────────────────────────────────────
export function exportCSV(dorks) {
  // V-01: All fields go through csvEscape()
  // V-12: UTF-8 BOM prepended
  const header = [
    "Query", "Category", "Risk", "Description", "Operators", "Sensitivity Note",
  ].map(csvEscape);

  const rows = dorks.map((d) => [
    csvEscape(d.query),
    csvEscape(d.category),
    csvEscape(d.risk),
    csvEscape(d.description),
    csvEscape((d.operators || []).join(", ")),
    csvEscape(d.sensitivity_note),
  ]);

  const csv = [
    DISCLAIMER,
    header.join(","),
    ...rows.map((r) => r.join(",")),
  ].join("\n");

  const blob = new Blob([UTF8_BOM + csv], { type: "text/csv;charset=utf-8;" });
  downloadBlob(blob, `recondork-${Date.now()}.csv`);
}

// ─── TXT Export ───────────────────────────────────────────────────────────────
export function exportTXT(dorks) {
  const lines = [
    "# ReconDork Export",
    DISCLAIMER,
    `# Generated : ${new Date().toISOString()}`,
    `# Total     : ${dorks.length}`,
    "",
    ...dorks.map(
      (d, i) =>
        `[${String(i + 1).padStart(2, "0")}] ${d.query}\n` +
        `     Category : ${d.category || "general"}\n` +
        `     Risk     : ${d.risk || "low"}\n` +
        `     Info     : ${d.description || ""}\n`
    ),
  ];
  const blob = new Blob([UTF8_BOM + lines.join("\n")], {
    type: "text/plain;charset=utf-8;",
  });
  downloadBlob(blob, `recondork-${Date.now()}.txt`);
}
